import { DSFieldRecord } from '../public/core';
import { OrderedMap } from 'immutable';
import { isPropertyGroupRecord } from '../types/PropertyGroupRecordType';
export const isMapOfDSFieldRecords = fields => {
  return !!fields && DSFieldRecord.isDSFieldRecord(fields.first());
};
export const isMapOfPropertyGroupRecords = fields => {
  return !!fields && isPropertyGroupRecord(fields.first());
};
export const getDSFieldRecordsFromPropertyGroupRecords = fields => {
  return fields.reduce((acc, propertyGroupRecord) => {
    const {
      properties
    } = propertyGroupRecord;
    const fieldRecords = {};
    properties.forEach(fieldRecord => fieldRecords[fieldRecord.name] = fieldRecord);
    return acc.merge(fieldRecords);
  }, OrderedMap());
};